import _ from "lodash";
import webStorageManager from "../managers/web-storage";
import { STORAGE_KEY_APP_DATA } from "../managers/constants";

const service = (() => {
  // Get a list of all Products
  const getAllProducts = () => {
    let appData = webStorageManager.get(STORAGE_KEY_APP_DATA);
    if (!appData || !appData.App || !appData.App.Products || !_.isArray(appData.App.Products)) return [];
    let products = appData.App.Products;
    return _.map(products, function(o) {
      return _.pick(o, ["ProductCode", "Product", "contractspecspage"]);
    });
  };

  // Get a list of all Lot Sizes mapped to Product
  const getAllLotSizesByProduct = (products, productCode) => {
    if (!products || !_.isArray(products)) return [];
    let prodObj = _.find(products, { ProductCode: productCode });
    return prodObj ? (prodObj.LotSizes && _.isArray(prodObj.LotSizes) ? __remapLotSizeObjects(prodObj.LotSizes) : []) : [];
  };

  // This function was written due to change in the structure
  // of the LotSizes array on Jan 25, 2018
  // https://cmestash.chicago.cme.com/projects/SIA/repos/client_liquidity_analytics/commits/e7233fbdffed46350085c955b60944df18606caa#App%20Filters%20Data.js
  const __remapLotSizeObjects = (lotSizes) => {
    let remapped = [];
    if (lotSizes && _.isArray(lotSizes) && lotSizes.length) {
      _.forEach(lotSizes, (lotSizeObj) => {
        remapped.push(_.map(lotSizeObj, (Val, Key) => ({ Key, Val }))[0]);
      });
    }
    return remapped;
  };

  // Get a list of all RTH Timings mapped to Product and Zone
  const getAllRTHTimingsByProductAndZone = (products, productCode, zoneCode) => {
    if (!products || !_.isArray(products)) return [];
    let prodObj = _.find(products, { ProductCode: productCode });
    return prodObj ? (prodObj["RTH"][zoneCode] ? prodObj["RTH"][zoneCode] : []) : [];
  };

  return { getAllProducts, getAllLotSizesByProduct, getAllRTHTimingsByProductAndZone };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/transformers/app-data.js